import React from 'react';
import { Card } from '@drone-js/core';
import { selectScreenSize } from 'store/slice/screen';
import { useSelector } from 'react-redux';

export const CardContainer: React.FC<React.PropsWithChildren<{ isCard: boolean }>> = ({ children, isCard }) => {
    const screenSize = useSelector(selectScreenSize);
    if (isCard) {
        return <Card p={screenSize.desktop ? '24' : '16'}>{children}</Card>;
    }
    return <>{children}</>;
};

CardContainer.displayName = 'CardContainer';
